import PropTypes from 'prop-types'
import clsx from 'clsx'

import useAttentionPulse, { PULS_KLASSE } from '../../shared/useAttentionPulse'

import styles from './style.module.scss'

/**
 * Der Knopf, der die Filterleiste oeffnet — mit der Zahl der gesetzten Filter.
 *
 * Steht ein Filter, leuchtet er beim Anzeigen kurz auf (zwei Schuebe zu drei
 * Blinkern, siehe `shared/useAttentionPulse`). Eine gefilterte Liste sieht sonst
 * aus wie eine kurze Liste: Die Auswahl wird pro Browser gemerkt, wer also von
 * einer anderen Seite zurueckkommt, sucht Eintraege, die es scheinbar nicht mehr
 * gibt.
 */
export default function BtnFilter(props) {
	const puls = useAttentionPulse(Boolean(props.count))

	return (
		<button
			type={props.type}
			disabled={props.loading || props.disabled}
			style={props.width ? { width: props.width } : {}}
			className={clsx(styles.root, props.className, {
				[styles.filterActive]: !!props.count, //only when open === true
				[PULS_KLASSE]: puls.leuchtet
			})}
			onAnimationEnd={puls.onAnimationEnd}
			onClick={props.onClick}
		>
			{/*
			 * Der Trichter steht hier im Markup und nicht als Bilddatei: Er
			 * wechselt mit dem Knopf die Farbe (grün auf Weiß, weiß auf Orange),
			 * und ein `<img>` bringt seine Strichfarbe fest mit. `currentColor`
			 * nimmt die des Knopfes.
			 */}
			<svg className={styles.icon} width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.0028 15.75C7.49418 15.75 7.48779 14.2453 7.48779 11.6996C7.48779 9.15393 2.25 7.37038 2.25 4.57561C2.25 2.21478 4.34272 2.25003 8.9996 2.25003C13.6573 2.25003 15.75 2.21478 15.75 4.57561C15.75 7.37038 10.513 9.15393 10.513 11.6996C10.513 14.2453 10.5106 15.75 9.0028 15.75Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
			{props.children}
		</button>
	)
}

BtnFilter.propTypes = {
	className: PropTypes.string,
	width: PropTypes.number,
	type: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	icon: PropTypes.string,
	iconClassName: PropTypes.string,
	iconColor: PropTypes.string,
	iconSize: PropTypes.shape({
		w: PropTypes.number.isRequired,
		h: PropTypes.number.isRequired
	}),
	iconOrder: PropTypes.number,
	loading: PropTypes.bool,
	disabled: PropTypes.bool,
	onClick: PropTypes.func,

	theme: PropTypes.string
}

BtnFilter.defaultProps = {
	type: 'button',
	className: '',
	loading: false,
	disabled: false,
	iconOrder: 1,
	children: []
}
